import { useState, useEffect } from 'react'
import { CredentialCheckResponse } from '../../types/credentials'
import { getShifts } from 'api/shifts'

export const useShiftDetails = (
  credentialChecks: CredentialCheckResponse[] | undefined
) => {
  const [shiftDetails, setShiftDetails] = useState<Record<number, any>>({})

  useEffect(() => {
    const loadShiftDetails = async () => {
      if (!credentialChecks) return

      const shiftPromises = credentialChecks.map(async (check) => {
        try {
          const shifts = await getShifts({
            shiftId: check.shift.id,
          })
          return {
            id: check.shift.id,
            data: shifts[0],
          }
        } catch {
          return null
        }
      })

      const results = await Promise.all(shiftPromises)
      const newShiftDetails: Record<number, unknown> = {}
      results.forEach((result) => {
        if (result) {
          newShiftDetails[result.id] = result.data
        }
      })
      setShiftDetails(newShiftDetails)
    }

    loadShiftDetails()
  }, [credentialChecks])

  return shiftDetails
}
